export default "__VITE_ASSET__b85054a3__"